export function isProductionBuild() {
  return import.meta.env.PROD === true
}

export function isDevelopmentBuild() {
  return import.meta.env.DEV === true
}
